<template>
  <div class="drq-overlay">
    <div class="drq-card">

      <!-- Step dots (6 for v2) -->
      <div class="drq-dots">
        <span
          v-for="n in 6"
          :key="n"
          class="drq-dot"
          :class="{ 'drq-dot--active': n === slide, 'drq-dot--done': n < slide }"
        ></span>
      </div>

      <!-- Slide 1: post count slider -->
      <div v-if="slide === 1">
        <span class="drq-emoji">📱</span>
        <p class="drq-question">D'après toi, combien de publications sur l'apparence physique (fitness, "glow-up", avant/après) as-tu vues en scrollant ?</p>
        <div class="drq-slider-wrap">
          <div class="drq-value">{{ q1Guess }} <span>publication(s)</span></div>
          <input
            type="range"
            class="drq-slider"
            :style="slider1Style"
            min="0"
            max="40"
            :value="q1Guess"
            @input="q1Guess = parseInt($event.target.value)"
          />
          <div class="drq-slider-labels"><span>0</span><span>40</span></div>
        </div>
        <button class="drq-btn" @click="slide = 2">Valider ma réponse →</button>
      </div>

      <!-- Slide 2: post count reveal -->
      <div v-if="slide === 2">
        <div class="drq-reveal-number">{{ harmfulPostCount }}</div>
        <div class="drq-reveal-label">publication(s) sur l'apparence physique</div>
        <div class="drq-feedback">
          <span class="drq-feedback-emoji">{{ reveal1.emoji }}</span>
          <span v-html="reveal1.text"></span>
        </div>
        <button class="drq-btn" @click="slide = 3">Continuer →</button>
      </div>

      <!-- Slide 3: Yes/No question -->
      <div v-if="slide === 3">
        <span class="drq-emoji">🤔</span>
        <p class="drq-question">Est-ce que tu as déjà eu envie de modifier ton alimentation ou ta routine sportive après avoir vu ce type de publications sur les réseaux ?</p>
        <div class="drq-btn-row">
          <button class="drq-btn-choice" @click="answerQ2('oui')">Oui</button>
          <button class="drq-btn-choice" @click="answerQ2('non')">Non</button>
        </div>
      </div>

      <!-- Slide 4: Yes/No reveal -->
      <div v-if="slide === 4">
        <span class="drq-emoji">{{ reveal2.emoji }}</span>
        <div class="drq-feedback">
          <span v-html="reveal2.text"></span>
        </div>
        <p class="drq-source">Source : BVA / Fondation Jean-Jaurès, 2023</p>
        <button class="drq-btn" @click="slide = 5">Continuer →</button>
      </div>

      <!-- Slide 5: commercial logic -->
      <div v-if="slide === 5">
        <span class="drq-emoji">💡</span>
        <p class="drq-message">
          <strong>Tout ça, ce n'est pas un hasard.</strong> Derrière les publications sur l'apparence physique, il y a une mécanique simple : amplifier des <strong>insécurités</strong>, et derrière, <strong>proposer une solution</strong> pour y remédier (un produit, un complément alimentaire, un programme). <strong>C'est le business des réseaux sociaux.</strong>
        </p>
        <button class="drq-btn" @click="slide = 6">Continuer →</button>
      </div>

      <!-- Slide 6: 97% stat + finish -->
      <div v-if="slide === 6">
        <p class="drq-message drq-message--small">🔍 D'ailleurs, savais-tu que…</p>
        <div class="drq-stat">
          <span class="drq-stat__number">97%</span>
          <span class="drq-stat__text">des influenceurs européens postent du contenu commercial ?</span>
        </div>
        <div class="drq-final">
          ✨ Prendre conscience de ça, c'est pouvoir regarder ces contenus <strong>différemment</strong>, voire en regarder moins.
        </div>
        <button class="drq-btn" style="margin-top:24px" @click="finish">J'ai compris ➝</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    condition:        { type: String, default: '' },
    harmfulPostCount: { type: Number, default: 0 },
  },
  data() {
    return {
      slide: 1,
      q1Guess: 0,
      q2Answer: null,
    };
  },
  computed: {
    slider1Style() {
      const pct = (this.q1Guess / 40 * 100) + '%';
      return { '--val': pct };
    },
    reveal1() {
      const z = this.harmfulPostCount;
      if (this.q1Guess < z) {
        return {
          emoji: '😮',
          text: "C'est plus que tu ne le pensais ! C'est normal, on en voit souvent plus qu'on ne le croit.",
        };
      } else if (this.q1Guess === z) {
        return {
          emoji: '🎯',
          text: "Bonne réponse ! Mais attention, souvent on en voit plus qu'on ne le croit sur les réseaux.",
        };
      } else {
        return {
          emoji: '😅',
          text: "C'est moins que tu ne le pensais, mais attention ! On en voit souvent plus qu'on ne le croit.",
        };
      }
    },
    reveal2() {
      if (this.q2Answer === 'oui') {
        return {
          emoji: '🤝',
          text: "Tu n'es pas seul(e). Ces publications peuvent affecter l'image que tu as de ton corps, <strong>sans même que tu t'en rendes compte</strong> : <strong>près d'1 jeune sur 2</strong> dit qu'elles leur donnent envie de changer leur apparence. C'est énorme !",
        };
      } else {
        return {
          emoji: '🙌',
          text: "<strong>Près d'1 jeune sur 2</strong> répond que ces publications leur donnent envie de changer leur apparence. C'est énorme ! Même si ce n'est pas ton cas, sache que ces publications peuvent affecter l'image que tu as de ton corps, <strong>sans même que tu t'en rendes compte</strong>.",
        };
      }
    },
  },
  methods: {
    answerQ2(answer) {
      this.q2Answer = answer;
      this.slide = 4;
    },
    finish() {
      this.$emit('done', { q1Guess: this.q1Guess, q2Answer: this.q2Answer });
    },
  },
};
</script>

<style lang="scss" scoped>
.drq-overlay {
  position: fixed;
  inset: 0;
  background: #0f0f0f;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 50;
  overflow-y: auto;
}

.drq-card {
  background: #1a1a1a;
  border-radius: 20px;
  padding: 36px 32px;
  max-width: 480px;
  width: 100%;
  border: 1px solid #2a2a2a;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.6);
  color: #f0f0f0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.drq-dots {
  display: flex;
  gap: 6px;
  margin-bottom: 32px;
}

.drq-dot {
  height: 4px;
  border-radius: 2px;
  flex: 1;
  background: #2a2a2a;
  transition: background 0.4s;

  &--active { background: #FE2C55; }
  &--done   { background: #b01830; }
}

.drq-emoji {
  font-size: 2rem;
  margin-bottom: 16px;
  display: block;
}

.drq-question {
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.5;
  color: #f0f0f0;
  margin-bottom: 28px;
}

.drq-slider-wrap {
  margin-bottom: 28px;
}

.drq-slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #888;
  margin-top: 8px;
}

.drq-value {
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  color: #FE2C55;
  margin-bottom: 12px;
  letter-spacing: -1px;

  span {
    font-size: 1rem;
    font-weight: 400;
    color: #888;
  }
}

.drq-slider {
  width: 100%;
  height: 6px;
  -webkit-appearance: none;
  background: linear-gradient(
    to right,
    #FE2C55 0%,
    #FE2C55 var(--val, 0%),
    #2a2a2a var(--val, 0%),
    #2a2a2a 100%
  );
  border-radius: 3px;
  outline: none;
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #FE2C55;
    box-shadow: 0 0 0 3px rgba(254, 44, 85, 0.2);
    cursor: pointer;
    transition: transform 0.15s;

    &:hover { transform: scale(1.2); }
  }
}

.drq-btn {
  width: 100%;
  padding: 14px 20px;
  background: #FE2C55;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
  margin-top: 8px;

  &:hover   { background: #e02040; }
  &:active  { transform: scale(0.98); }
}

.drq-btn-row {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.drq-btn-choice {
  flex: 1;
  padding: 16px 20px;
  background: transparent;
  color: #f0f0f0;
  border: 1.5px solid #2a2a2a;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #FE2C55;
    background: rgba(254, 44, 85, 0.13);
  }
}

.drq-reveal-number {
  font-size: 3.5rem;
  font-weight: 800;
  color: #FE2C55;
  letter-spacing: -2px;
  margin: 16px 0 4px;
  line-height: 1;
}

.drq-reveal-label {
  font-size: 0.85rem;
  color: #888;
  margin-bottom: 20px;
}

.drq-feedback {
  background: #222;
  border-left: 3px solid #b01830;
  border-radius: 0 12px 12px 0;
  padding: 16px 18px;
  margin-bottom: 20px;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #e0e0e0;

  ::v-deep strong { color: #fff; }
}

.drq-feedback-emoji {
  font-size: 1.4rem;
  margin-bottom: 8px;
  display: block;
}

.drq-source {
  font-size: 0.72rem;
  color: #555;
  margin-bottom: 16px;
}

.drq-message {
  font-size: 0.95rem;
  line-height: 1.7;
  color: #ddd;
  margin-bottom: 16px;

  &--small {
    color: #aaa;
    font-size: 0.9rem;
  }

  ::v-deep strong { color: #fff; }
}

.drq-stat {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #222;
  border-radius: 14px;
  padding: 18px;
  margin: 20px 0;

  &__number {
    font-size: 2.2rem;
    font-weight: 800;
    color: #FE2C55;
    white-space: nowrap;
  }

  &__text {
    font-size: 0.88rem;
    color: #ccc;
    line-height: 1.5;
  }
}

.drq-final {
  background: linear-gradient(135deg, #1a0008, #2a0010);
  border-radius: 14px;
  padding: 20px;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #e0e0e0;
  border: 1px solid #FE2C55;
  margin-top: 16px;

  ::v-deep strong { color: #fff; }
}
</style>
